import LayoutActividad from "../../../components/LayoutActividad";
import { modulo13 } from "../../../routes/Module13";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";

import Imagen1 from "../../../images/modulo13/chanchan.png";
import Imagen2 from "../../../images/modulo13/ruinas.png";

const Actividad4 = () => {
  const infoUnidad = modulo13.content[2];
  const infoAct = modulo13.content[2].activities[5];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[2].name}: ${modulo13.content[2].activities[6].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[6].path}`,
    titlePrev: `${modulo13.content[2].name}: ${modulo13.content[2].activities[4].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[2].path}/${modulo13.content[2].activities[4].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <h2 className="mb-5">{infoAct.name}</h2>
      <div className="bg-light p-4 p-md-5 mt-5">
        <div className="row mt-3 align-items-center">
          <div className="col-md-8 col-12 p-4 p-md-3">
          <h2 className="mb-4">Las ciudades<br /> en el antiguo Perú</h2>

            <p>
              A lo largo de nuestra historia, se construyeron importantes
              ciudades en el Perú. Los <strong>asentamientos</strong> eran distintos dependiendo
              del territorio donde se construían. Así, en la costa, por ejemplo,
              encontramos ciudades de barro como Chan Chan, en La Libertad,
              mientras que en la sierra, hay ciudades como Piquillacta, en el
              Cuzco, que combina diversos materiales de construcción.
            </p>
          </div>
          <div className="col-md-4 col-12 text-center">
            <img src={Imagen2} className="img-fluid w-100" alt="Peruanos" />
          </div>
          <div className="col-md-3 col-12 text-center">
            <img src={Imagen1} className="img-fluid w-100" alt="Peruanos" />
          </div>
          
          <div className="col-md-9 col-12 p-4 p-md-3">
            <p>
              Estas ciudades, además, fueron producto de una cuidadosa {" "}
              <strong>planificación</strong> para proveer a sus habitantes de los recursos y
              servicios necesarios.
            </p>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida a un o una estudiante que lea el título del texto: Las ciudades
            en el antiguo Perú. Antes de leer el texto, pregunte lo siguiente:
            <ul>
              <li>
                <i>
                  “¿Cómo creen que fueron las ciudades del antiguo Perú? Puede
                  comentar que las ciudades del antiguo Perú fueron muy
                  distintas entre sí. Ello se debió a que se adaptaban a la
                  diversidad de territorios existentes.
                </i>
              </li>
              <li>
                <i>
                  ¿Utilizaron siempre los mismos materiales en su construcción?
                  Los materiales fueron distintos. Algunas ciudades, por
                  ejemplo, fueron de adobe, mientras que otras se construyeron
                  con piedra. Los materiales dependían de la disponibilidad de
                  recursos de cada zona.
                </i>
              </li>
              <li>
                <i>
                  ¿Qué servicios creen que ofrecieron? Algunas ciudades se
                  construyeron en las partes altas para facilitar la visión ante
                  cualquier enemigo; otras presentaron andenes, acequias y
                  almacenes para cubrir las necesidades de sus pobladores”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Pida que lean en voz alta el texto.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad4;
